<template>
  <widget>
    <div slot="header">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white"
           width="24px" height="26px" v-on:click="back()" >
        <path d="M0 0h24v24H0V0z" fill="none"/>
        <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
      </svg>
      <div>
          <h1>FLOA {{ kind }}</h1>
          Une question par tchat ?
      </div>
      <i class="material-icons large" v-on:click="download()" >download</i>
      <i class="material-icons" v-on:click="back()" >close</i>
    </div>
  </widget>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import Widget from './Widget'

dayjs.extend(utc)

export default {
  name: 'FloaBankNPay',
  components: { Widget },
  computed: {
    kind () {
      return process.env.VUE_APP_FLOA_KIND
    },
    messages () {
      return this.$store.getters.messages
    }
  },
  methods: {
    back () {
      const selectors = [
        'div.gb-zm-wrapper div.gb-zm-button-button',
        'li.gb-zm-channel div.chayall span.gb-zm-channel-btn',
        'li.gb-zm-channel div.webchat span.gb-zm-channel-btn'
      ]
      let selector
      let found = false
      selectors.forEach((selector) => {
        if (document.querySelector(selector) !== null) {
          found = true
          document.querySelector(selector).click()
        }
      })
      if (found === false) {
        if (window.GbZenMsg.$settings.options !== null &&
            window.GbZenMsg.$settings.options.instances &&
            window.GbZenMsg.$settings.options.instances.length > 0) {
          // the widget can be handled by external buttons
          selector = window.GbZenMsg.$settings.options.instances[0]
          if (document.querySelector(selector)) {
            document.querySelector(selector).click()
          }
        }
      }
    },
    download () {
      console.log('>>>')
      const date = dayjs().format('DD-MM-YYYY')
      const title = 'floa-' + date
      const filename = title + '.html'
      const body = document.querySelector('.gb-zb-widget').innerHTML
      const stylesheets = []
      for (var stylesheet in document.styleSheets) {
        if (stylesheet.href && stylesheet.href.indexOf('cdn.greenbureau') > -1) {
          stylesheets.push(stylesheet.href)
        }
      }
      const links = stylesheets.map(
        stylesheet => `<link rel="stylesheet" href="${stylesheet}" >`)
      const html = `<!doctype html>
        <html lang="en">
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
          <title>${ title }</title>
          ${links.join()}
          <style>
          .gb-zb-widget-wrapper, .gb-zb-widget {
            height: 100vh !important;
            left: 0px;
            top: 0px;
            width: 100vw !important;
          }</style>
          </head>
          <body >
            <div class="gb-zb-widget-wrapper">
              <div class="gb-zb-widget">
                ${ body }
              </div>
            </div>
          </body>
        </html>`
      const uri = 'data:text/html;filename=' + filename + ',' + encodeURIComponent(html)
      const link = document.createElement('a')
      if (typeof link.download === 'string') {
        document.body.appendChild(link) // Firefox requires the link to be in the body
        link.download = filename
        link.href = uri
        link.click()
        document.body.removeChild(link) // remove the link when done
      } else {
        location.replace(uri)
      }
    },
    toggle () {
      const step = this.$store.getters.step === 'button' ? 'chatbox' : 'button'
      this.$store.dispatch({
        type: 'changeStep',
        step: step
      })
      this.$store.dispatch({
        type: 'initWebsocket'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$light-grey: #F2F2F2;
$primary: $VUE_APP_FLOA_COLOR;

@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');

.gb-zb-button {
  background-color: $primary;
}

::v-deep .gb-zb-widget-wrapper {
  background: $primary;
  border-radius: 8px;
  bottom: 20px;
  box-shadow: 0px 50px 190px 0px rgba(0, 15, 88, 0.3);
  font-family: Roboto, "Helvetica Neue", Arial, sans-serif;
  max-width: 22em;
  min-height: 400px;
  min-width: 300px;
  position: fixed;
  right: 20px;
  z-index: 1030;

  &.gb-zm-fixed-button {
    bottom: 90px;
  }

  @media(max-width: 640px) {
    border-radius: 0px;
    bottom: 0px;
    height: 100%;
    max-width: 100%;
    right: 0px;
    width: 100%;
  }
}

::v-deep  .gb-zb-widget-wrapper * {
  font-family: Roboto, "Helvetica Neue", Arial, sans-serif;
}

::v-deep  .gb-zb-widget-wrapper .gb-zb-widget-header {
  color: #fff;
  cursor: pointer;
  padding: 20px !important;

  > div > div {
    display: flex;
    justify-content: space-between;

    i {
      color: #fff;
      cursor: pointer;
    }

    svg {
      cursor: pointer;
    }
  }

  > div > div > div {
    color: #fff;
    height: 40px;
    margin: 0;
    width: calc(100% - 50px);

    h1 {
      font-size: 16px;
      font-weight: 600 !important;
      margin: 0;
    }

    p {}
  }

  .gb-zb-reset {
    font-size: 24px;

    @media(max-width: 640px) {
      margin-right: 24px;
    }
  }
}

::v-deep .gb-zb-widget-wrapper .gb-zb-widget {
  background-color: #fff;
  height: calc(400px - 120px);

  @media(max-width: 640px) {
    height: calc(100% - 140px);
  }
}

::v-deep .gb-zb-widget-wrapper .gb-zb-choice {
  border: 1px solid $primary !important;
  color: $primary !important;
}

::v-deep .gb-zb-widget-wrapper .gb-zb-form {
  background-color: $light-grey;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  height: 60px;
  width: 100%;
}

  ::v-deep .gb-zb-widget-wrapper .gb-zb-form .emoji-menu-wrapper {
    height: 35px;
    flex-shrink: 0;

    &, & > button {
      display: flex;
      align-items: center;
    }

    #EmojiPicker {
      display: block;
      height: 300px;
      left: 50%;
      transform: translateX(-50%);
      bottom: 56px;

      .container-emoji {
        max-height: 30vh;

        .emoji {
          border: none !important;
        }
      }
    }
  }

  ::v-deep .gb-zb-widget-wrapper .gb-zb-form form {
    align-items: flex-start;
    background-color: $light-grey;
    display: flex;
    height: 30px;
    padding: 0;
    margin-top: 0;
    width: calc(100% - 30px);
  }

    ::v-deep .gb-zb-widget-wrapper .gb-zb-form form input {
      background-color: transparent;
      border: none;
      color: #687177;
      display: block;
      height: 30px;
      margin-top: 0px !important;
      width: calc(100% - 60px);

      &[type="file"] {
        display: none;
      }
    }

::v-deep .gb-zb-widget-wrapper .gb-zb-form .gb-zb-send,
::v-deep .gb-zb-widget-wrapper .gb-zb-form .gb-zb-upload {
  background: none;
  border: none;
  height: 40px;
  text-align: center;
  vertical-align: top;
  width: 40px;
}

::v-deep .gb-zb-widget-wrapper .gb-zb-form label  {
  margin: 5px 10px;
  text-align: center;
}

::v-deep .gb-zb-widget-wrapper .gb-zb-form .gb-zb-send i.material-icons,
::v-deep .gb-zb-widget-wrapper .gb-zb-form .gb-zb-emoji i.material-icons,
::v-deep .gb-zb-widget-wrapper .gb-zb-form .gb-zb-upload i.material-icons {
  color: #000;
  padding: 0px;
}

::v-deep  .gb-zb-widget-wrapper .gb-zb-msg-left {
  background: $light-grey;
  border-radius: 12px 24px 24px 24px;
  color: #000;

  a {
    color: #336941;

    &:hover {
      text-decoration: underline;
    }
  }
}

::v-deep  .gb-zb-widget-wrapper .gb-zb-msg-right {
  background: $primary;
  border-radius: 24px 24px 12px 24px;
  color: #fff;
}

::v-deep .gb-zb-widget-wrapper .gb-zb-choice.gb-zb-disabled {
  background: #EBEFF2!important;
  border: 1px solid #687177 !important;
  color: #687177!important;
  cursor: default;
}

::v-deep .gb-zb-widget-wrapper .gb-zb-satisfaction-survey h2 {
  font-size: 1.25rem;
}
</style>
